import { upgradeNg1Dependency } from '@go-modules/common/ng1-upgrade-factory';
import { EVENT_NAMES } from '@go-modules/services/event/event-names.constants';
import { EventService } from '@go-modules/services/event/event.service';
import { SessionStorageService } from './session-storage.service';
import { RouterService } from '@go-modules/services/router/router.service';

export class SessionManagerService {
	public static readonly NG1_INJECTION_NAME = 'sessionManager' as const;

	/* @ngInject */
	constructor (
		private $rootScope: ng.IRootScopeService,
		private $cookies: ng.cookies.ICookiesService,
		private $document: ng.IDocumentService,
		private $injector: ng.auto.IInjectorService,
		private sessionStorage: SessionStorageService
	) {
		this.sessionStorage.setPrefix('goreact-');
	}

	/**
	 * Whether session has ended
	 *
	 * @returns {boolean}
	 */
	public isEnded () {
		return !this.isActive();
	}

	public isActive () {
		return this.$cookies.get('gr_expires_at') != null;
	}

	public isLockedOut (responseData) {
		return !!responseData?.remainingAccountLockSeconds;
	}

	public getAccountLockedTime (): number {
		let remainingAccountLockTimeMinutes = 0;
		const accountLockTime = sessionStorage.getItem('accountLockTime');

		if (accountLockTime) {
			sessionStorage.removeItem('accountLockTime');
			remainingAccountLockTimeMinutes = this.convertToMinutes(accountLockTime);
		}
		return remainingAccountLockTimeMinutes;
	}

	public convertToMinutes (timeInSeconds): number {
		timeInSeconds = parseInt(timeInSeconds, 10);
		return Math.ceil(timeInSeconds / 60);
	}

	public startVisibilityWatcher (): void {
		// Check version on tab focus
		const listener = () => {
			if (this.$document[0].visibilityState === 'visible') {
				// This will cause a 401 if someone comes back to the tab, but only "root"
				const ngxRouterService = this.$injector.get('ngxRouterService') as RouterService;
				if (this.isEnded() && ngxRouterService.getCurrentRouteName()?.startsWith('root')) {
					(this.$injector.get('eventService') as EventService).broadcast(EVENT_NAMES.AUTH_ENDED);
				}
			}
		};
		this.$document[0].addEventListener('visibilitychange', listener);

		// While this never happens in real life, if we don't do this in the test it'll
		// be a memory leak that holds onto the entire ng1/ngx system
		this.$rootScope.$on('$destroy', () => {
			this.$document[0].removeEventListener('visibilitychange', listener);
		});
	}
}

export const sessionManagerToken = upgradeNg1Dependency(SessionManagerService);
